export default "__VITE_ASSET__DiOUixIh__"